import { IconButton, InputAdornment } from '@material-ui/core';
import { WatchLater } from '@material-ui/icons';
import useStyles from './styles';
import { TextField } from '../index';
import { ITimeField } from './types';

function TimeField({ label, name, placeholder, required, disabled }: ITimeField) {
  const classes = useStyles();

  return (
    <TextField
      name={name}
      label={label}
      placeholder={placeholder}
      type="time"
      className={classes.timeField}
      required={required}
      disabled={disabled}
      clearIconLeftPosition={'20%'}
      inputProps={{
        pattern: '^((d+:)?d+:)?d*$',
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton size="small" disabled={disabled}>
              <WatchLater color="inherit" />
            </IconButton>
          </InputAdornment>
        ),
      }}
      data-testid={`time-field-${name}`}
    />
  );
}

export default TimeField;
